import { DiscountTypeEnum } from 'src/app/enum/discount-type.enum';
import { ConfigurationHbm } from '../common-hbm-tunnel-dtos';
import { BaseCreateUpdateTunnel } from '../base-create-update-tunnel';
import { BaseInstallationDto } from '../base-installation-dto';
import { BaseTunnelFundingDto } from '../base-tunnel-funding-dto';
import { BaseTunnelInstallationPrice } from '../base-tunnel-installation-price';
import { PricedItem } from '../priced-item';

export class StorageInspiration {
  inspirationId?: number;
  legsId?: number;
  frontId?: number;
  boxId?: number;
  handlesId?: number;

  toStorageInspirationDto(): StorageInspirationDto {
    const dto = new StorageInspirationDto();
    dto.inspirationId = this.inspirationId?.toString();
    dto.legsId = this.legsId?.toString();
    dto.frontId = this.frontId?.toString();
    dto.boxId = this.boxId?.toString();
    dto.handlesId = this.handlesId?.toString();
    return dto;
  }
}
export class StorageInspirationDto {
  inspirationId?: string;
  legsId?: string;
  frontId?: string;
  boxId?: string;
  handlesId?: string;

  toStorageInspiration(): StorageInspiration {
    const entity = new StorageInspiration();
    entity.inspirationId = this.inspirationId ? parseInt(this.inspirationId, 10) : undefined;
    entity.legsId = this.legsId ? parseInt(this.legsId, 10) : undefined;
    entity.frontId = this.frontId ? parseInt(this.frontId, 10) : undefined;
    entity.boxId = this.boxId ? parseInt(this.boxId, 10) : undefined;
    entity.handlesId = this.handlesId ? parseInt(this.handlesId, 10) : undefined;
    return entity;
  }
}

export type StorageConfiguration = ConfigurationHbm & {
  storageConfigurationId: string;
};

export type BaseStorageConfigurationDto = {
  id: string;
  storageConfigurationId: string;
  title?: string;
  bom?: string;
};

export type StorageCreateUpdateTunnel = BaseCreateUpdateTunnel & {
  bom: string;
  uuidhbm: string;
  storageInspiration: StorageInspirationDto;
};

export type StorageTunnelPricingDto = {
  financing?: StorageTunnelFinancingDto;
  financingWithInstallation?: StorageTunnelFinancingDto;
  discountEnum: DiscountTypeEnum;
  installationPrices?: StorageTunnelInstallationPrice;
  conceptionPrices?: StorageTunnelConceptionPrice;
  deliveryPrice?: PricedItem;
  totalWithFinancing?: number;
  totalWithoutFinancing?: PricedItem;
  downPayment?: number;
  houseMoreThan2YearsOld: boolean;
  withInstallation: boolean;
};

export type StorageTunnelFinancingDto = BaseTunnelFundingDto;
export type StorageTunnelInstallationPrice = BaseTunnelInstallationPrice;

export type StorageTunnelConceptionPrice = {
  delta?: number;
  withInstallation?: StorageTunnelConceptionDetailPrice;
  withoutInstallation?: StorageTunnelConceptionDetailPrice;
  categoryTotals?: Record<string, PricedItem>;
};

export type StorageTunnelConceptionDetailPrice = {
  productsPrice?: PricedItem;
  totalPrice?: PricedItem;
};

export type StorageInstallationDto = BaseInstallationDto & {
  installationPrice?: StorageTunnelInstallationPrice;
  conceptionPrices?: StorageTunnelConceptionPrice;
};
